import { FilterViewModel } from '../regulation';

export class AuditTrailMasterFilter {
    users: FilterViewModel[];
    screens: FilterViewModel[];
    functions: FilterViewModel[];
    actions: FilterViewModel[];
    keywords: FilterViewModel[];

    constructor() {
        this.users = [];
        this.screens = [];
        this.functions = [];
        this.actions = [];
        this.keywords = [];
    }
}